'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jobDetails = require('./job-details.html');

var _jobDetails2 = _interopRequireDefault(_jobDetails);

var _jobDetails3 = require('./job-details.controller');

var _jobDetails4 = _interopRequireDefault(_jobDetails3);

require('./job-details.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jobDetailsComponent = {
  template: _jobDetails2.default,
  controller: _jobDetails4.default,
  controllerAs: 'vm'
};

exports.default = jobDetailsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/job-details/job-details.component.js
 **/